export default __webpack_public_path__ + "static/media/girl_image.67f9e3c5.png";